var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsensys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 4793.76 1081.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "consensys-logo-horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consensys"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-Logo"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_",
    "data-name": "<Path>",
    d: "M493.65,1078a1.84,1.84,0,1,0,1.85,1.85A1.85,1.85,0,0,0,493.65,1078Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M442.42,1060.24a3.65,3.65,0,0,0-3.68,3.67,3.69,3.69,0,1,0,3.68-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M393.15,1037.16a5.54,5.54,0,0,0,0,11.07,5.54,5.54,0,1,0,0-11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M346.39,1009a7.39,7.39,0,1,0,7.42,7.39A7.38,7.38,0,0,0,346.39,1009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M302.68,976.11a9.24,9.24,0,1,0,9.23,9.23A9.23,9.23,0,0,0,302.68,976.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M262.45,938.72a11.08,11.08,0,1,0,11.11,11.11A11.07,11.07,0,0,0,262.45,938.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M226.2,897.35a12.93,12.93,0,1,0,13,12.93A12.93,12.93,0,0,0,226.2,897.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M194.36,852.28a14.8,14.8,0,1,0,14.8,14.8A14.79,14.79,0,0,0,194.36,852.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M184.89,820.2a16.64,16.64,0,1,0-16.65,16.64A16.68,16.68,0,0,0,184.89,820.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M167.05,770.29a18.49,18.49,0,1,0-18.52,18.48A18.5,18.5,0,0,0,167.05,770.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M155.92,718.24a20.34,20.34,0,1,0-20.34,20.34A20.35,20.35,0,0,0,155.92,718.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M151.73,665a22.18,22.18,0,1,0-22.17,22.15A22.14,22.14,0,0,0,151.73,665Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_13",
    "data-name": "<Path>",
    d: "M130.53,635.34a24,24,0,1,0-24-24A24,24,0,0,0,130.53,635.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_14",
    "data-name": "<Path>",
    d: "M112.65,558.29a25.87,25.87,0,1,0,25.86-25.89A25.84,25.84,0,0,0,112.65,558.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_15",
    "data-name": "<Path>",
    d: "M889.1,954.49a1.64,1.64,0,1,0,1.63,1.63A1.66,1.66,0,0,0,889.1,954.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_16",
    "data-name": "<Path>",
    d: "M841.59,977.8a3.25,3.25,0,0,0-3.3,3.24,3.29,3.29,0,1,0,6.57,0A3.26,3.26,0,0,0,841.59,977.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_17",
    "data-name": "<Path>",
    d: "M791.74,996a4.91,4.91,0,0,0,0,9.82,4.91,4.91,0,1,0,0-9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_18",
    "data-name": "<Path>",
    d: "M740.07,1008.84a6.54,6.54,0,0,0,0,13.07,6.54,6.54,0,1,0,0-13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_19",
    "data-name": "<Path>",
    d: "M687.19,1016.13a8.18,8.18,0,1,0,8.1,8.16A8.19,8.19,0,0,0,687.19,1016.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_20",
    "data-name": "<Path>",
    d: "M633.65,1017.83a9.8,9.8,0,1,0,9.8,9.82A9.77,9.77,0,0,0,633.65,1017.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_21",
    "data-name": "<Path>",
    d: "M580,1013.91a11.43,11.43,0,1,0,11.46,11.41A11.41,11.41,0,0,0,580,1013.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_22",
    "data-name": "<Path>",
    d: "M527,1004.23a13.07,13.07,0,1,0,13.07,13A13.05,13.05,0,0,0,527,1004.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_23",
    "data-name": "<Path>",
    d: "M475.38,987.91a14.68,14.68,0,1,0,14.7,14.66A14.7,14.7,0,0,0,475.38,987.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_24",
    "data-name": "<Path>",
    d: "M426.18,964.93a16.33,16.33,0,1,0,16.3,16.32A16.31,16.31,0,0,0,426.18,964.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_25",
    "data-name": "<Path>",
    d: "M398.15,953.59a18,18,0,1,0-18,18A17.94,17.94,0,0,0,398.15,953.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_26",
    "data-name": "<Path>",
    d: "M338.26,900.6a19.58,19.58,0,1,0,19.56,19.57A19.63,19.63,0,0,0,338.26,900.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_27",
    "data-name": "<Path>",
    d: "M301,860.31a21.25,21.25,0,1,0,21.22,21.24A21.24,21.24,0,0,0,301,860.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_28",
    "data-name": "<Path>",
    d: "M269.15,861.29a22.87,22.87,0,1,0-22.85-22.88A22.82,22.82,0,0,0,269.15,861.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_29",
    "data-name": "<Path>",
    d: "M267.6,791.51A24.47,24.47,0,1,0,243.12,816,24.49,24.49,0,0,0,267.6,791.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_30",
    "data-name": "<Path>",
    d: "M1081.2,587.54a1.48,1.48,0,0,0-1.49,1.43,1.52,1.52,0,0,0,1.49,1.5,1.47,1.47,0,0,0,1.45-1.5A1.43,1.43,0,0,0,1081.2,587.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_31",
    "data-name": "<Path>",
    d: "M1065.25,637.31a2.91,2.91,0,1,0,2.89,2.9A2.89,2.89,0,0,0,1065.25,637.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_32",
    "data-name": "<Path>",
    d: "M1044,685.08a4.4,4.4,0,1,0,4.43,4.39A4.4,4.4,0,0,0,1044,685.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_33",
    "data-name": "<Path>",
    d: "M1017.7,730.43a5.83,5.83,0,1,0,5.85,5.82A5.83,5.83,0,0,0,1017.7,730.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_34",
    "data-name": "<Path>",
    d: "M986.63,772.67A7.31,7.31,0,1,0,994,780,7.34,7.34,0,0,0,986.63,772.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_35",
    "data-name": "<Path>",
    d: "M951.11,811.41a8.78,8.78,0,1,0,8.77,8.78A8.77,8.77,0,0,0,951.11,811.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_36",
    "data-name": "<Path>",
    d: "M911.57,846.26a10.23,10.23,0,1,0,10.27,10.2A10.19,10.19,0,0,0,911.57,846.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_37",
    "data-name": "<Path>",
    d: "M868.4,876.58a11.71,11.71,0,1,0,11.65,11.73A11.75,11.75,0,0,0,868.4,876.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_38",
    "data-name": "<Path>",
    d: "M821.55,901.23a13.17,13.17,0,1,0,13.14,13.15A13.2,13.2,0,0,0,821.55,901.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_39",
    "data-name": "<Path>",
    d: "M771.62,919.47a14.65,14.65,0,1,0,14.6,14.62A14.63,14.63,0,0,0,771.62,919.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_40",
    "data-name": "<Path>",
    d: "M719.57,931a16.1,16.1,0,1,0,16.07,16.12A16.13,16.13,0,0,0,719.57,931Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_41",
    "data-name": "<Path>",
    d: "M666.26,935.54a17.55,17.55,0,1,0,17.54,17.59A17.57,17.57,0,0,0,666.26,935.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_42",
    "data-name": "<Path>",
    d: "M631.63,952.13a19,19,0,1,0-19,19A19.05,19.05,0,0,0,631.63,952.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_43",
    "data-name": "<Path>",
    d: "M580.07,944.18a20.47,20.47,0,1,0-20.49,20.46A20.46,20.46,0,0,0,580.07,944.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_44",
    "data-name": "<Path>",
    d: "M530,929.34a22,22,0,1,0-22,22A21.95,21.95,0,0,0,530,929.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_45",
    "data-name": "<Path>",
    d: "M482.21,907.92a23.39,23.39,0,1,0-23.37,23.4A23.36,23.36,0,0,0,482.21,907.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_46",
    "data-name": "<Path>",
    d: "M957.4,195a1.46,1.46,0,1,0,0-2.91,1.46,1.46,0,0,0,0,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_47",
    "data-name": "<Path>",
    d: "M982.4,244a2.93,2.93,0,1,0-2.93-2.94A2.9,2.9,0,0,0,982.4,244Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_48",
    "data-name": "<Path>",
    d: "M1002.18,295.31a4.38,4.38,0,1,0-4.37-4.38A4.37,4.37,0,0,0,1002.18,295.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_49",
    "data-name": "<Path>",
    d: "M1016.68,348.43a5.86,5.86,0,1,0-5.84-5.84A5.83,5.83,0,0,0,1016.68,348.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_50",
    "data-name": "<Path>",
    d: "M1018.3,395.5a7.31,7.31,0,1,0,7.29-7.34A7.32,7.32,0,0,0,1018.3,395.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_51",
    "data-name": "<Path>",
    d: "M1028.93,440.24a8.77,8.77,0,1,0,8.79,8.79A8.79,8.79,0,0,0,1028.93,440.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_52",
    "data-name": "<Path>",
    d: "M1026.6,492.38a10.26,10.26,0,1,0,10.27,10.24A10.22,10.22,0,0,0,1026.6,492.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_53",
    "data-name": "<Path>",
    d: "M1018.59,544a11.7,11.7,0,1,0,11.73,11.7A11.68,11.68,0,0,0,1018.59,544Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_54",
    "data-name": "<Path>",
    d: "M1017.05,607.28a13.17,13.17,0,1,0-13.14,13.18A13.12,13.12,0,0,0,1017.05,607.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_55",
    "data-name": "<Path>",
    d: "M982.53,641.89a14.62,14.62,0,1,0,14.62,14.62A14.6,14.6,0,0,0,982.53,641.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_56",
    "data-name": "<Path>",
    d: "M954.91,686.43A16.07,16.07,0,1,0,971,702.5,16.07,16.07,0,0,0,954.91,686.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_57",
    "data-name": "<Path>",
    d: "M921.47,726.91A17.54,17.54,0,1,0,939,744.42,17.51,17.51,0,0,0,921.47,726.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_58",
    "data-name": "<Path>",
    d: "M882.86,762.64a19,19,0,1,0,19,19A19,19,0,0,0,882.86,762.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_59",
    "data-name": "<Path>",
    d: "M839.74,793.06a20.46,20.46,0,1,0,20.47,20.49A20.47,20.47,0,0,0,839.74,793.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_60",
    "data-name": "<Path>",
    d: "M792.82,817.56a21.95,21.95,0,1,0,21.93,22A21.94,21.94,0,0,0,792.82,817.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_61",
    "data-name": "<Path>",
    d: "M742.89,835.77a23.4,23.4,0,1,0,23.42,23.39A23.41,23.41,0,0,0,742.89,835.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_62",
    "data-name": "<Path>",
    d: "M590.32,2.92a1.46,1.46,0,1,0-1.48-1.47A1.47,1.47,0,0,0,590.32,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_63",
    "data-name": "<Path>",
    d: "M641.54,20.34a2.93,2.93,0,1,0-2.95-2.94A2.93,2.93,0,0,0,641.54,20.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_64",
    "data-name": "<Path>",
    d: "M690.82,43a4.39,4.39,0,1,0-4.4-4.37A4.39,4.39,0,0,0,690.82,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_65",
    "data-name": "<Path>",
    d: "M737.58,70.79a5.85,5.85,0,1,0-5.87-5.85A5.84,5.84,0,0,0,737.58,70.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_66",
    "data-name": "<Path>",
    d: "M781.29,103.29A7.29,7.29,0,1,0,774,96,7.27,7.27,0,0,0,781.29,103.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_67",
    "data-name": "<Path>",
    d: "M821.49,140.3a8.79,8.79,0,1,0-8.74-8.8A8.8,8.8,0,0,0,821.49,140.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_68",
    "data-name": "<Path>",
    d: "M857.8,181.3a10.25,10.25,0,1,0-10.27-10.2A10.24,10.24,0,0,0,857.8,181.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_69",
    "data-name": "<Path>",
    d: "M889.64,226a11.71,11.71,0,1,0-11.72-11.72A11.7,11.7,0,0,0,889.64,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_70",
    "data-name": "<Path>",
    d: "M915.73,274.29a13.15,13.15,0,1,0-13.2-13.15A13.17,13.17,0,0,0,915.73,274.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_71",
    "data-name": "<Path>",
    d: "M920.8,311a14.63,14.63,0,1,0,14.64-14.59A14.59,14.59,0,0,0,920.8,311Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_72",
    "data-name": "<Path>",
    d: "M932.32,363.12A16.09,16.09,0,1,0,948.42,347,16.05,16.05,0,0,0,932.32,363.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_73",
    "data-name": "<Path>",
    d: "M936.85,416.41a17.57,17.57,0,1,0,17.55-17.58A17.55,17.55,0,0,0,936.85,416.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_74",
    "data-name": "<Path>",
    d: "M972.41,470a19,19,0,1,0-19,19A19,19,0,0,0,972.41,470Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_75",
    "data-name": "<Path>",
    d: "M965.91,523.07a20.47,20.47,0,1,0-20.43,20.48A20.46,20.46,0,0,0,965.91,523.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_76",
    "data-name": "<Path>",
    d: "M952.61,574.63a21.94,21.94,0,1,0-22,21.94A21.95,21.95,0,0,0,952.61,574.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_77",
    "data-name": "<Path>",
    d: "M909.23,600.4a23.41,23.41,0,1,0,23.45,23.41A23.42,23.42,0,0,0,909.23,600.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_78",
    "data-name": "<Path>",
    d: "M194.9,126.66a1.45,1.45,0,0,0,1.45-1.45,1.48,1.48,0,0,0-1.45-1.47,1.47,1.47,0,0,0-1.47,1.47A1.44,1.44,0,0,0,194.9,126.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_79",
    "data-name": "<Path>",
    d: "M242.37,103.18a2.91,2.91,0,1,0-2.93-2.89A2.91,2.91,0,0,0,242.37,103.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_80",
    "data-name": "<Path>",
    d: "M292.22,84.84a4.41,4.41,0,1,0-4.37-4.38A4.38,4.38,0,0,0,292.22,84.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_81",
    "data-name": "<Path>",
    d: "M343.88,71.82A5.85,5.85,0,1,0,338,66,5.81,5.81,0,0,0,343.88,71.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_82",
    "data-name": "<Path>",
    d: "M396.78,64.33A7.31,7.31,0,1,0,389.45,57,7.29,7.29,0,0,0,396.78,64.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_83",
    "data-name": "<Path>",
    d: "M450.33,62.48a8.78,8.78,0,1,0-8.8-8.76A8.73,8.73,0,0,0,450.33,62.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_84",
    "data-name": "<Path>",
    d: "M503.93,66.23A10.23,10.23,0,1,0,493.72,56,10.18,10.18,0,0,0,503.93,66.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_85",
    "data-name": "<Path>",
    d: "M557,75.73A11.7,11.7,0,1,0,545.3,64,11.67,11.67,0,0,0,557,75.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_86",
    "data-name": "<Path>",
    d: "M608.59,91.9a13.16,13.16,0,1,0-13.15-13.17A13.22,13.22,0,0,0,608.59,91.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_87",
    "data-name": "<Path>",
    d: "M657.8,114.71a14.63,14.63,0,1,0-14.58-14.63A14.6,14.6,0,0,0,657.8,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_88",
    "data-name": "<Path>",
    d: "M687.7,127.71a16.08,16.08,0,1,0,16.08-16.06A16.07,16.07,0,0,0,687.7,127.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_89",
    "data-name": "<Path>",
    d: "M745.75,178.71a17.54,17.54,0,1,0-17.59-17.57A17.56,17.56,0,0,0,745.75,178.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_90",
    "data-name": "<Path>",
    d: "M783,218.8a19,19,0,1,0-19-19A19,19,0,0,0,783,218.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_91",
    "data-name": "<Path>",
    d: "M814.82,222.43a20.47,20.47,0,1,0,20.47,20.47A20.46,20.46,0,0,0,814.82,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_92",
    "data-name": "<Path>",
    d: "M818.91,289.85a21.91,21.91,0,1,0,21.89-21.94A21.88,21.88,0,0,0,818.91,289.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_93",
    "data-name": "<Path>",
    d: "M837.07,339.72a23.39,23.39,0,1,0,23.43-23.37A23.42,23.42,0,0,0,837.07,339.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_94",
    "data-name": "<Path>",
    d: "M873.37,366.9a24.87,24.87,0,1,0,24.86,24.87A24.88,24.88,0,0,0,873.37,366.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_95",
    "data-name": "<Path>",
    d: "M2.77,489.59a2.76,2.76,0,1,0,0,5.51,2.76,2.76,0,1,0,0-5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_96",
    "data-name": "<Path>",
    d: "M18.75,435.61a5.52,5.52,0,1,0,5.49,5.53A5.55,5.55,0,0,0,18.75,435.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_97",
    "data-name": "<Path>",
    d: "M48.26,391.87a8.3,8.3,0,1,0-8.32,8.27A8.31,8.31,0,0,0,48.26,391.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_98",
    "data-name": "<Path>",
    d: "M66.24,356.13a11,11,0,1,0-11-11A11.06,11.06,0,0,0,66.24,356.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_99",
    "data-name": "<Path>",
    d: "M97.33,315.16a13.79,13.79,0,1,0-13.78-13.78A13.76,13.76,0,0,0,97.33,315.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_100",
    "data-name": "<Path>",
    d: "M132.84,277.68a16.54,16.54,0,1,0-16.54-16.54A16.54,16.54,0,0,0,132.84,277.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_101",
    "data-name": "<Path>",
    d: "M172.38,244.22a19.34,19.34,0,1,0-19.3-19.34A19.32,19.32,0,0,0,172.38,244.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_102",
    "data-name": "<Path>",
    d: "M215.48,215.09a22.07,22.07,0,1,0-22-22.05A22.08,22.08,0,0,0,215.48,215.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_103",
    "data-name": "<Path>",
    d: "M262.18,191.39a24.82,24.82,0,1,0-24.81-24.84A24.82,24.82,0,0,0,262.18,191.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_104",
    "data-name": "<Path>",
    d: "M311.87,174A27.54,27.54,0,0,0,339,150.47,30.24,30.24,0,0,0,390.75,147a33,33,0,0,0,50.78,2.41,35.78,35.78,0,0,0,49.64,8.7,34,34,0,0,0,4.6,6,40.29,40.29,0,0,0-23.52,10.84,38.31,38.31,0,0,0-56.84,5.76A35.81,35.81,0,0,0,393.1,173a36.26,36.26,0,0,0-32.84,21,34.13,34.13,0,0,0-52.46,20.57,32,32,0,0,0-48.66,27.3v.12a29.85,29.85,0,0,0-44.78,25.88,30.36,30.36,0,0,0,1.19,8.29,27.43,27.43,0,0,0-14.44-4.16,27.75,27.75,0,1,0,27.73,27.77,28.85,28.85,0,0,0-.94-6.89,29.84,29.84,0,0,0,46.15-24,31.87,31.87,0,0,0,17.1,5c.56,0,1.17-.08,1.76-.08a36.59,36.59,0,0,0-11.86,24.31,35.11,35.11,0,0,0-41.63,34.5,28.1,28.1,0,0,0,.28,4.11,27.17,27.17,0,0,0-3.85-.24,33.24,33.24,0,0,0-33.25,33.24,31.84,31.84,0,0,0,1.75,10.59c-.68,0-1.32-.09-2-.09A31.35,31.35,0,0,0,175.62,428a6.94,6.94,0,0,0-.91,0,29.53,29.53,0,0,0-20.16,51.14c-.44,0-.84-.13-1.24-.13a27.82,27.82,0,1,0,19.46,8c.62,0,1.28.08,1.94.08a29.44,29.44,0,0,0,21.67-9.5c0,.34,0,.69,0,1A34.39,34.39,0,0,0,203,498.94a32.58,32.58,0,0,0-10.2,55.52,31,31,0,0,0-1.5,55.65,29.34,29.34,0,0,0,6.74,54.79,27.68,27.68,0,0,0,12.5,52.41,26.87,26.87,0,0,0,5.09-.52,25.8,25.8,0,1,0,7.85-1.32,25.67,25.67,0,0,0-4.75.46,27.62,27.62,0,0,0,19.6-26.37c0-.7-.16-1.29-.22-2a31.61,31.61,0,0,0,16.38,9.56,30.64,30.64,0,0,0,23.41,50.53h.67A29.19,29.19,0,0,0,302.26,794a29.89,29.89,0,0,0,8.49-1.26,27.79,27.79,0,0,0,23.13,43.14,27.33,27.33,0,0,0,17.27-6.19,26.29,26.29,0,1,0,38.92-1,33.88,33.88,0,0,0,10.12-1.74v.36a32.18,32.18,0,0,0,17.53,28.64,22.52,22.52,0,0,0-4.82-.51,25.14,25.14,0,1,0,11.75,3,31.09,31.09,0,0,0,7.71,1,32.07,32.07,0,0,0,17-4.87,30.66,30.66,0,0,0,52.72,18.69,29.22,29.22,0,0,0,54.64,9.16,27.72,27.72,0,0,0,54.74-2.59,26.25,26.25,0,1,0,26.75-28.05,34.61,34.61,0,0,0,5.94-8.45,32.13,32.13,0,0,0,32.79,8.16,24.87,24.87,0,1,0,14-4.27,23.65,23.65,0,0,0-7.12,1.17,32.23,32.23,0,0,0,14.7-20.27,30.41,30.41,0,0,0,19.8,7.27A30.74,30.74,0,0,0,749,804.71c0-.23-.07-.47-.07-.66a28.93,28.93,0,0,0,17.11,5.56,29.24,29.24,0,0,0,29.27-29.23,28,28,0,0,0-1.27-8.49,27.69,27.69,0,0,0,37-40.4,25.82,25.82,0,0,0,17.08,6.44,26.32,26.32,0,1,0,0-52.64A26,26,0,0,0,830,692.64a35.71,35.71,0,0,0-1.72-10.18h.3a32.23,32.23,0,0,0,28.66-17.52,25.29,25.29,0,0,0-.5,4.8A25.18,25.18,0,1,0,859.8,658a31.85,31.85,0,0,0,1-7.7,32.47,32.47,0,0,0-4.9-17,30.65,30.65,0,0,0,18.68-52.71,29.23,29.23,0,0,0,9.18-54.62,27.7,27.7,0,0,0-2.59-54.72,26.5,26.5,0,1,0-4.76-.13,27.61,27.61,0,0,0-11.49,51.85,29.18,29.18,0,0,0-15.68,49.38,30.64,30.64,0,0,0-22.34,45.89,32.17,32.17,0,0,0-30.47,32.09,30.84,30.84,0,0,0,1.45,9.32,12.27,12.27,0,0,0-1.47-.11,33.66,33.66,0,0,0-33.65,33.65,22.06,22.06,0,0,0,.14,2.41,32.28,32.28,0,0,0-5.29-.44,35,35,0,0,0-34.69,30.06,37.86,37.86,0,0,0-9.58-1.31A36.6,36.6,0,0,0,680.23,745a32,32,0,0,0-49.47,11.81,32.16,32.16,0,0,0-52,6.55,32.24,32.24,0,0,0-48.55-2.07,32.27,32.27,0,0,0-48-13A32.25,32.25,0,0,0,437.48,726a32.15,32.15,0,0,0-37.35-30.8,32.21,32.21,0,0,0-31-39.52,32.14,32.14,0,0,0-20.89-43.81,32.22,32.22,0,0,0-9.41-47.57,32.27,32.27,0,0,0,1.62-49.87,32.44,32.44,0,0,0,16.87-21.05,32,32,0,0,0-4.93-26.32,32.18,32.18,0,0,0,23.23-42.26,32.25,32.25,0,0,0,33.54-37A32.28,32.28,0,0,0,449,359.44,32.22,32.22,0,0,0,494.22,342,31.86,31.86,0,0,0,519,350.1h0a31.82,31.82,0,0,0,24-14.86,32.12,32.12,0,0,0,48.88,4.48,32.13,32.13,0,0,0,47.53,14.95A32.33,32.33,0,0,0,655.68,377h-.06a32.11,32.11,0,0,0,23.07,3.08c.87,1.2,1.8,2.36,2.76,3.44a31.49,31.49,0,0,0,8,19.23,6,6,0,0,0,.68.65c16.43,17.19,54.56,58.92,47.43,114.79-1.81,13.92,6,20.95,16,10.19,60.55-65.27,51.07-145.44,49.71-154.76a53.3,53.3,0,0,0-3.92-17.37,52.82,52.82,0,0,0,1.08-10.5A51.85,51.85,0,0,0,780,304.51a50.8,50.8,0,0,0,.91-9.37,49.66,49.66,0,0,0-31.08-46.07,47.47,47.47,0,0,0-40.11-46,45.24,45.24,0,0,0-44.44-37c-.82,0-1.57.08-2.44.11a42.78,42.78,0,0,0-40.71-29.6A41.57,41.57,0,0,0,611.35,138a40.58,40.58,0,0,0-54.73-19.61,38.36,38.36,0,0,0-56.86-10.62,35.74,35.74,0,0,0-56.94-1.42,33,33,0,0,0-55.77,7.21,30.32,30.32,0,0,0-53.32,16.18A27.53,27.53,0,1,0,311.87,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_105",
    "data-name": "<Path>",
    d: "M126.52,885.64a2.12,2.12,0,0,0-2.09,2.15,2.15,2.15,0,0,0,2.09,2.15,2.2,2.2,0,0,0,2.18-2.15A2.17,2.17,0,0,0,126.52,885.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_106",
    "data-name": "<Path>",
    d: "M101.62,836a4.25,4.25,0,0,0-4.27,4.24,4.26,4.26,0,1,0,8.52,0A4.23,4.23,0,0,0,101.62,836Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_107",
    "data-name": "<Path>",
    d: "M81.79,784a6.41,6.41,0,1,0,6.4,6.44A6.43,6.43,0,0,0,81.79,784Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_108",
    "data-name": "<Path>",
    d: "M67.3,730.22a8.53,8.53,0,1,0,8.55,8.53A8.52,8.52,0,0,0,67.3,730.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_109",
    "data-name": "<Path>",
    d: "M69,685.89a10.68,10.68,0,1,0-10.65,10.65A10.67,10.67,0,0,0,69,685.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_110",
    "data-name": "<Path>",
    d: "M67.85,632.31A12.81,12.81,0,1,0,55,645.15,12.8,12.8,0,0,0,67.85,632.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_111",
    "data-name": "<Path>",
    d: "M42.42,578.74A14.93,14.93,0,1,0,57.37,563.8,14.9,14.9,0,0,0,42.42,578.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_112",
    "data-name": "<Path>",
    d: "M65.39,542.75a17.08,17.08,0,1,0-17.11-17.08A17.07,17.07,0,0,0,65.39,542.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_113",
    "data-name": "<Path>",
    d: "M80.09,454.87a19.21,19.21,0,1,0,19.18,19.21A19.22,19.22,0,0,0,80.09,454.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_114",
    "data-name": "<Path>",
    d: "M101.4,446.2a21.36,21.36,0,1,0-21.31-21.35A21.36,21.36,0,0,0,101.4,446.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_115",
    "data-name": "<Path>",
    d: "M129.06,402.34a23.48,23.48,0,1,0-23.53-23.46A23.44,23.44,0,0,0,129.06,402.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_116",
    "data-name": "<Path>",
    d: "M188.09,336.92a25.61,25.61,0,1,0-25.62,25.6A25.63,25.63,0,0,0,188.09,336.92Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_117",
    "data-name": "<Path>",
    d: "M1505.36,745.39a199.3,199.3,0,0,1-79.16-16,203.85,203.85,0,0,1-64.44-43.72,207.35,207.35,0,0,1-43.31-65,205.6,205.6,0,0,1,0-159A204.71,204.71,0,0,1,1426.1,352.73a201,201,0,0,1,159.47.29,210.92,210.92,0,0,1,65.3,45.25,39.08,39.08,0,0,1,9,15,23.2,23.2,0,0,1-2.6,20.21c-4.61,6.91-11.33,10.71-20,11.28h-.28c-9.51,0-16.16-2.78-21.52-8.26a268.71,268.71,0,0,0-50-33.17,129.45,129.45,0,0,0-60.23-14.65,147.39,147.39,0,0,0-58.85,12.05,151.72,151.72,0,0,0-47.92,33,157.64,157.64,0,0,0-32,48.64,152,152,0,0,0,0,117.71,151,151,0,0,0,80,80.94,146.62,146.62,0,0,0,58.8,12,151.56,151.56,0,0,0,61.5-12.63,149,149,0,0,0,49.15-35,30.76,30.76,0,0,1,16.18-9.45,26.55,26.55,0,0,1,6.1-.77,23.38,23.38,0,0,1,13.35,4.27,25.52,25.52,0,0,1,9.84,20.91c0,8.17-2.49,15-7.39,20.43a197.31,197.31,0,0,1-66.44,47.59A201.89,201.89,0,0,1,1505.36,745.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M1930.09,744.71a200,200,0,0,1-79.23-16,204.47,204.47,0,0,1-64.37-43.41A206.61,206.61,0,0,1,1743.06,621a205.22,205.22,0,0,1,0-158.36,211.17,211.17,0,0,1,43.43-64.68,203.52,203.52,0,0,1,64.37-43.7,204,204,0,0,1,158.36,0,204.59,204.59,0,0,1,108.4,108.38,203.8,203.8,0,0,1,0,158.36A202.61,202.61,0,0,1,2074,685.41a210.86,210.86,0,0,1-64.73,43.34A199.47,199.47,0,0,1,1930.09,744.71Zm0-354.17a150.25,150.25,0,0,0-58.82,11.74,147.88,147.88,0,0,0-48,32.29,155,155,0,0,0-32.13,48.36,154.24,154.24,0,0,0,0,117.66,151.4,151.4,0,0,0,197.69,80.07,154.66,154.66,0,0,0,48.35-32.12A152.27,152.27,0,0,0,2069.58,483a155.23,155.23,0,0,0-32.41-48.35,152.47,152.47,0,0,0-48.31-32.34A150.55,150.55,0,0,0,1930.09,390.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_118",
    "data-name": "<Path>",
    d: "M2493.28,746a26.1,26.1,0,0,1-26.17-26.14V487a93.76,93.76,0,0,0-7.68-37.89,100.54,100.54,0,0,0-52.77-52.62,95.91,95.91,0,0,0-75.68,0,98.89,98.89,0,0,0-31,21.22,103.5,103.5,0,0,0-21,31.45A94.91,94.91,0,0,0,2271.2,487V719.82a25.19,25.19,0,0,1-7.68,18.56,25.44,25.44,0,0,1-18.44,7.58,26.07,26.07,0,0,1-26.22-26.14V487a149.31,149.31,0,0,1,11.65-58.46,147.08,147.08,0,0,1,32.09-47.82,151,151,0,0,1,47.78-32.25,147.67,147.67,0,0,1,117,.05,151.45,151.45,0,0,1,80.09,79.95,145.74,145.74,0,0,1,12,58.53V719.82a25.36,25.36,0,0,1-7.54,18.51A25.87,25.87,0,0,1,2493.28,746Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_119",
    "data-name": "<Path>",
    d: "M2750.36,746a164.61,164.61,0,0,1-56.56-9.65,152.44,152.44,0,0,1-46.58-26.84,126,126,0,0,1-31.57-40.12A108.81,108.81,0,0,1,2604.1,620a24.92,24.92,0,0,1,49.84,0,61.5,61.5,0,0,0,7.18,29.06,77.1,77.1,0,0,0,20.05,24,104.46,104.46,0,0,0,30.54,16.38,119,119,0,0,0,38,6,121.19,121.19,0,0,0,38.41-6.08,110.64,110.64,0,0,0,31.5-16.49A71.46,71.46,0,0,0,2840.2,649a52.45,52.45,0,0,0,6-28.52,58.21,58.21,0,0,0-8.84-26.61A89.65,89.65,0,0,0,2816.77,571a116.36,116.36,0,0,0-29.39-16.81,167.79,167.79,0,0,0-35-9.82,204.42,204.42,0,0,1-50.78-10.11,166.8,166.8,0,0,1-43.36-21.6,111.2,111.2,0,0,1-30.49-31.5,75,75,0,0,1-11.9-41.06,81.46,81.46,0,0,1,11.09-41.39,108.77,108.77,0,0,1,29.91-32.94c12.37-9.22,27-16.56,43.63-22a178,178,0,0,1,106,0c16.45,5.43,31.12,12.77,43.6,22,12.75,9.56,22.76,20.58,29.87,32.94a81.08,81.08,0,0,1,11.19,41.39,26.07,26.07,0,0,1-26.17,26.12,24,24,0,0,1-18.49-8.16c-4.54-5-7.06-11.72-7.63-20a32.39,32.39,0,0,0-6.7-17.6,65.41,65.41,0,0,0-18-16.32,102,102,0,0,0-27.42-11.77,126,126,0,0,0-33.18-4.39,130.79,130.79,0,0,0-34.19,4.39,97.86,97.86,0,0,0-27.37,11.72,61.36,61.36,0,0,0-17.62,17.17,34,34,0,0,0-6.19,19.44c0,6.44,2.4,12.22,7.44,17.74a75.77,75.77,0,0,0,21,16,162,162,0,0,0,28.69,11.89,175.51,175.51,0,0,0,29.13,6.5,206.64,206.64,0,0,1,54.95,13.69c17.38,7.15,32.63,16.13,45.28,26.7a120.46,120.46,0,0,1,30.73,38.31,104.94,104.94,0,0,1,11.19,47.83A110.26,110.26,0,0,1,2885,669a122.16,122.16,0,0,1-31.57,40.19A159.91,159.91,0,0,1,2750.36,746Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_120",
    "data-name": "<Path>",
    d: "M3014.24,746a26.07,26.07,0,0,1-26.2-26.14V362.6a25.62,25.62,0,0,1,7.68-18.59,25.18,25.18,0,0,1,18.52-7.63h218a26,26,0,0,1,26.1,26.22,25.07,25.07,0,0,1-7.59,18.43,25.45,25.45,0,0,1-18.51,7.64H3040.4V513.75h135.82a26.17,26.17,0,1,1,0,52.34H3040.4V693.63h191.88a25.93,25.93,0,0,1,26.1,26.19,25.21,25.21,0,0,1-7.59,18.51,25.48,25.48,0,0,1-18.51,7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_121",
    "data-name": "<Path>",
    d: "M3603.07,746a26.14,26.14,0,0,1-26.24-26.14V487a93.61,93.61,0,0,0-7.69-37.89,100.59,100.59,0,0,0-52.72-52.62,95.79,95.79,0,0,0-75.63,0,97.16,97.16,0,0,0-31,21.22,105.17,105.17,0,0,0-21.12,31.4A95.63,95.63,0,0,0,3381,487V719.82a26.15,26.15,0,1,1-52.3,0V487a150.24,150.24,0,0,1,91.43-138.55,148.12,148.12,0,0,1,117.11.07,150.52,150.52,0,0,1,47.68,32.2,152.23,152.23,0,0,1,32.27,47.75,145.5,145.5,0,0,1,12,58.53V719.82A26,26,0,0,1,3603.07,746Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_122",
    "data-name": "<Path>",
    d: "M3860.17,746a164.86,164.86,0,0,1-56.56-9.65A151.26,151.26,0,0,1,3757,709.47a128.06,128.06,0,0,1-31.64-40.1A109.83,109.83,0,0,1,3713.84,620a24.41,24.41,0,0,1,7.28-17.57A25,25,0,0,1,3763.8,620a61.3,61.3,0,0,0,7.11,29,75.63,75.63,0,0,0,20,24,103.1,103.1,0,0,0,30.56,16.45,118.67,118.67,0,0,0,38.08,6,121.19,121.19,0,0,0,38.41-6.08,109.61,109.61,0,0,0,31.45-16.49A73.55,73.55,0,0,0,3950,649,52.23,52.23,0,0,0,3956,620.5a58.92,58.92,0,0,0-8.84-26.61A89.47,89.47,0,0,0,3926.55,571a113.72,113.72,0,0,0-29.38-16.78,165,165,0,0,0-35.08-9.82,202.64,202.64,0,0,1-50.7-10.11A165.73,165.73,0,0,1,3768,512.7a111.67,111.67,0,0,1-30.47-31.5,75.12,75.12,0,0,1-11.93-41.06,83,83,0,0,1,11.09-41.39,109.16,109.16,0,0,1,30-32.94c12.43-9.22,27.05-16.56,43.55-22a178.21,178.21,0,0,1,106,0c16.5,5.43,31.14,12.77,43.62,22a108.11,108.11,0,0,1,29.87,32.94,81.73,81.73,0,0,1,11.19,41.39,25.55,25.55,0,0,1-7.76,18.54,24.65,24.65,0,0,1-18.41,7.58,24,24,0,0,1-18.56-8.21c-4.49-4.89-7.06-11.62-7.56-19.85a32.47,32.47,0,0,0-6.72-17.6,66.4,66.4,0,0,0-18.06-16.37,100.66,100.66,0,0,0-27.39-11.77,122.06,122.06,0,0,0-33.25-4.39,132,132,0,0,0-34.19,4.39,95.54,95.54,0,0,0-27.27,11.72,61.65,61.65,0,0,0-17.63,17.17,34.11,34.11,0,0,0-6.21,19.44c0,6.46,2.47,12.22,7.39,17.74a78,78,0,0,0,21.13,16,159.14,159.14,0,0,0,28.74,11.89,177.69,177.69,0,0,0,29,6.5,205.9,205.9,0,0,1,55,13.69,172.62,172.62,0,0,1,45.32,26.7,121.56,121.56,0,0,1,30.64,38.22,104.65,104.65,0,0,1,11.28,47.92,110.74,110.74,0,0,1-11.52,49.6,124.09,124.09,0,0,1-31.64,40.19,160,160,0,0,1-103,36.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_123",
    "data-name": "<Path>",
    d: "M4254.25,746a26.07,26.07,0,0,1-26.2-26.14V586.69L4067,378.59a25.53,25.53,0,0,1-5.64-18.83,24.14,24.14,0,0,1,9.21-17.47,26.3,26.3,0,0,1,16.81-6c9.08.63,15.08,3.89,19.59,9.46l147.41,189.52,150.2-189.5a24.32,24.32,0,0,1,17.57-9.38h.44c8,0,13.61,2,18.43,5.81a24.56,24.56,0,0,1,9.46,17.6,26.57,26.57,0,0,1-5.86,18.82L4280.42,586.74V719.82a25.21,25.21,0,0,1-7.62,18.56A25.62,25.62,0,0,1,4254.25,746Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c56dd",
    id: "_Path_124",
    "data-name": "<Path>",
    d: "M4647.5,746a165.39,165.39,0,0,1-56.63-9.65,152.18,152.18,0,0,1-46.53-26.84,128.55,128.55,0,0,1-31.62-40.12,108.82,108.82,0,0,1-11.5-49.34,24.9,24.9,0,0,1,42.57-17.57,24.31,24.31,0,0,1,7.3,17.57,62,62,0,0,0,7.1,29.06,77.36,77.36,0,0,0,20.12,24,103.34,103.34,0,0,0,30.52,16.38,118.23,118.23,0,0,0,38,6,121.22,121.22,0,0,0,38.43-6.08,110.18,110.18,0,0,0,31.48-16.49A73.59,73.59,0,0,0,4737.34,649a51.56,51.56,0,0,0,6-28.52,60.07,60.07,0,0,0-8.78-26.61A92.36,92.36,0,0,0,4713.91,571a115.57,115.57,0,0,0-29.38-16.78,168.59,168.59,0,0,0-35.06-9.82,202.4,202.4,0,0,1-50.75-10.11,166.33,166.33,0,0,1-43.43-21.6,111.42,111.42,0,0,1-30.44-31.5A75.08,75.08,0,0,1,4513,440.14,82.49,82.49,0,0,1,4524,398.75a109.5,109.5,0,0,1,30-32.94c12.39-9.22,27-16.56,43.55-22a178.3,178.3,0,0,1,106.07,0,151.09,151.09,0,0,1,43.5,22,107.63,107.63,0,0,1,30,32.89,82.38,82.38,0,0,1,11.14,41.39,26.19,26.19,0,0,1-26.22,26.12,23.7,23.7,0,0,1-18.44-8.16c-4.54-4.9-7.18-11.62-7.73-19.9a32,32,0,0,0-6.63-17.6,63.82,63.82,0,0,0-18.12-16.37,101.27,101.27,0,0,0-27.32-11.77,122.39,122.39,0,0,0-33.26-4.39,131,131,0,0,0-34.16,4.39,95.18,95.18,0,0,0-27.27,11.72,59.87,59.87,0,0,0-17.65,17.17,33.9,33.9,0,0,0-6.22,19.44c0,6.44,2.35,12.22,7.4,17.74a77.37,77.37,0,0,0,21.1,16,159.54,159.54,0,0,0,28.69,11.89,178.89,178.89,0,0,0,29.07,6.5,206.59,206.59,0,0,1,55,13.69c17.33,7.15,32.55,16.08,45.3,26.7a120.29,120.29,0,0,1,30.71,38.31,105.49,105.49,0,0,1,11.23,47.83,110.65,110.65,0,0,1-11.57,49.6,123.42,123.42,0,0,1-31.64,40.19A160.07,160.07,0,0,1,4647.5,746Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsensys);
export default __webpack_public_path__ + "static/media/consensys.193adf3409143149c5d7ba6da3fe2c7a.svg";
export { ForwardRef as ReactComponent };